
import { Component, Emit, Prop, Watch } from 'vue-property-decorator'
import Abpbase from '@/lib/abpbase'
import RightPanel from '@/components/right-panel/index.vue'
import Dolist from '@/entities/dolist'
import CommonTable from '@/components/common-table/index.vue'
import { ElTable } from 'element-ui/types/table'
import DoDetail from '@/entities/dodetail'
import PageRequest from '@/entities/page-request'
import dictAction from '@/mixins/dict-action'
import RightDrawer from '@/components/right-drawer/index.vue'
import util from '@/lib/util'
import TemperatureAttachment from '@/entities/temperatureattachment'

class TraceRequest extends PageRequest {
  traceId: string
  doNo: string
  type: string
}

@Component({
  components: {
    RightPanel,
    CommonTable,
    RightDrawer
  },
  mixins: [dictAction]
})
export default class DolistPanel extends Abpbase {
  name: 'DolistPanel'

  dictEpodDoMaster = 'epod_do_master'
  dictEpodDoDetail = 'epod_do_detail'

  @Prop({
    type: Object,
    default: () => {}
  })
  item: Dolist

  info: Dolist = new Dolist()

  gPSLocation: string

  showDrawer: boolean = false

  loading: boolean = false

  drawerLoading: boolean = false

  get composeFromAddress() {
    if (
      this.info.shipFromPostcode &&
      this.info.shipFromCity &&
      this.info.shipFromCountry
    ) {
      return `${this.info.shipFromPostcode} ${this.info.shipFromCity} ${this.info.shipFromCountry}`
    } else if (
      !this.info.shipFromPostcode &&
      !this.info.shipFromCity &&
      !this.info.shipFromCountry
    ) {
      return '--'
    }
    return `${this.info.shipFromPostcode || ''} ${this.info.shipFromCity ||
      ''} ${this.info.shipFromCountry || ''}`
  }

  get composeToAddress() {
    if (
      this.info.shipToPostcode &&
      this.info.shipToCity &&
      this.info.shipToCountry
    ) {
      return `${this.info.shipToPostcode} ${this.info.shipToCity} ${this.info.shipToCountry}`
    } else if (
      !this.info.shipToPostcode &&
      !this.info.shipToCity &&
      !this.info.shipToCountry
    ) {
      return '--'
    }
    return `${this.info.shipToPostcode || ''} ${this.info.shipToCity ||
      ''} ${this.info.shipToCountry || ''}`
  }

  tableDataList = []

  getTableRef(): ElTable {
    return this.$refs.detailTable as ElTable
  }

  table = this.$standardTableData({
    showPagination: false,
    height: null,
    columns: [
      {
        title: this.L('No.'),
        key: 'index',
        render: (h: any, ctx: any) => {
          return h('span', this.getTableRef().$scopedSlots.no(ctx))
        }
      },
      {
        title: this.L('Trace Id'),
        key: 'traceId',
        render: (h: any, ctx: any) => {
          return h('span', this.getTableRef().$scopedSlots.traceId(ctx.row))
        }
      },
      {
        title: this.L('Seal No.'),
        key: 'toteSealNo'
      },
      {
        title: this.L('Type'),
        key: 'type',
        render: (h: any, ctx: any) => {
          return h('span', this.getTableRef().$scopedSlots.traceType(ctx.row))
        }
      },
      {
        title: this.L('Status'),
        key: 'status',
        render: (h: any, ctx: any) => {
          return h('span', this.getTableRef().$scopedSlots.traceStatus(ctx.row))
        }
      }
    ]
  })

  @Emit('close')
  doExpandClose() {}

  @Watch('item', { deep: true, immediate: true })
  onItemChanged() {
    this.attachmentList = []
    this.getDetailById()
  }

  /**
   * 通过id获得详情
   */

  doDetailList: Array<DoDetail> = []

  async getDetailById() {
    if (!this.item || !this.item.id) {
      this.$message.warning('Data Exception')
      return
    }
    try {
      this.loading = true

      let res = await this.$store.dispatch({
        type: 'dolist/getDetailById',
        id: this.item.id
      })

      this.info = res || {}
      if(this.info.latitude != null && this.info.longtitude != null)
        this.gPSLocation = this.info.latitude.toString() + ", " + this.info.longtitude.toString()
      else
        this.gPSLocation = null

      await this.$store.dispatch({
        type: 'dolist/getTraceDetailById',
        id: this.item.id
      })

      this.tableDataList = this.$store.state.dolist.detailList

      this.getAttachmentPhotoByDOBatch()

    } catch (e) {
      console.log(e)
    } finally {
      this.loading = false
    }
  }

  selectRowData: DoDetail = null

  doTableRowClick(rowData: DoDetail) {
    this.selectRowData = rowData
    this.showDrawer = true
    this.doTraceTableSearch()

    //20210811 : set pagesize fixed to 6
    this.doTraceTablePageSizeChange(6)
  }

  traceRequest: TraceRequest = new TraceRequest()

  /**
   * 获得trace详情
   */
  async doTraceTableSearch() {
    if (!this.selectRowData) {
      return
    }
    this.traceRequest.maxResultCount = this.traceTablePagination.pageSize
    this.traceRequest.skipCount =
      (this.traceTablePagination.pageNo - 1) *
      this.traceTablePagination.pageSize
    this.drawerLoading = true
    this.traceRequest.traceId = this.selectRowData.traceId
    this.traceRequest.doNo = this.selectRowData.doNo
    this.traceRequest.type = this.selectRowData.type
    await this.$store.dispatch({
      type: 'dolist/getDetailsByTrace',
      data: this.traceRequest
    })
  }

  get traceTableLoading() {
    return this.$store.state.dolist.traceLoading
  }

  get traceTableDataList() {
    return this.$store.state.dolist.traceList
  }

  get traceTablePagination() {
    return {
      pageNo: this.$store.state.dolist.traceCurrentPage,
      pageSize: this.$store.state.dolist.tracePageSize,
      total: this.$store.state.dolist.traceTotalCount
    }
  }

  doTraceTablePageChange(pageNo: number) {
    this.$store.commit('dolist/setTraceCurrentPage', pageNo)
    this.doTraceTableSearch()
  }

  doTraceTablePageSizeChange(pageSize: number) {
    this.$store.commit('dolist/setTracePageSize', pageSize)
    this.doTraceTableSearch()
  }

  traceTable = this.$standardTableData({
    height: null,
    columns: [
      {
        title: this.L('Part No.#Description'),
        key: 'partNo',
        render: (h: any, ctx: any) => {
          return h(
            'span',
            this.getTraceTableRef().$scopedSlots.partDescriptionRow(ctx.row)
          )
        }
      },
      {
        title: this.L('UOM'),
        key: 'uom',
        width: '80'
      },
      {
        title: this.L('Qty'),
        key: 'qty',
        width: '80'
      },
      {
        title: this.L('Expiry Date'),
        key: 'expiryDate',
        width: '120',
        render: (h: any, ctx: any) => {
          return h(
            'span',
            this.getTraceTableRef().$scopedSlots.expiryDate(ctx.row)
          )
        }
      }
    ]
  })

  getTraceTableRef(): ElTable {
    return this.$refs.traceTable as ElTable
  }

  async doShowMap() {
    let res = await this.$store.dispatch({
      type: 'dolist/getTruckLocationByVehicleNo',
      data: this.info.vehicleNo
    })
    if (!res) {
      this.$message.warning('No results found')
      return
    }
    let url = `https://www.google.com/maps/search/?api=1&query=${res.latitude}%2C${res.longitude}`
    util.openLink(url)
  }

  async doShowMapForStore() {
    if (this.info.latitude == null || this.info.longtitude == null) {
      this.$message.warning('No results found')
      return
    }
    let url = `https://www.google.com/maps/search/?api=1&query=${this.info.latitude}%2C${this.info.longtitude}`
    util.openLink(url)
  }

  viewattachment: TemperatureAttachment = new TemperatureAttachment()

  attachmentList: Array<any> = []

  showAttachmentPhotoDialog = false

  currentAttachmentIndex: number

  isRecCompleted = false

  islastphoto = false

  isfirstphoto = false

  isphotoempty = false

  async getAttachmentPhotoByDOBatch() {
    if (!this.item || !this.item.id) {
      this.$message.warning('Data Exception')
      return
    }
    try {
      this.loading = true
      let res = await this.$store.dispatch({
        type: 'dolist/getAttachmentPhotoByDOBatch',
        doBatch: this.info.doNo
      })

      this.attachmentList = res.map(t => {
        return {
          id: t.id,
          src: "data:image/png;base64," + t.imageSource
        }
      })
      if(this.attachmentList.length <= 0){

        this.isphotoempty = true
      }
    } catch (e) {
      console.log(e)
    } finally {
      this.loading = false
    }
  }

  doViewAttachment(attachmentList: Array<any>, id: number) {

    for(let i = 1; i <= attachmentList.length; i++){

      if(attachmentList[i-1].id == id){
        this.viewattachment.imageSource = attachmentList[i-1].src
        this.currentAttachmentIndex = i-1
      }
    }

    this.checkPhotoPosition()

    this.showAttachmentPhotoDialog = true
  }

  doViewPreviousAttachment() {

    this.showAttachmentPhotoDialog = false
    this.currentAttachmentIndex = this.currentAttachmentIndex - 1
    this.viewattachment.imageSource = this.attachmentList[this.currentAttachmentIndex].src
    this.checkPhotoPosition()
    this.showAttachmentPhotoDialog = true

  }

  doViewNextAttachment() {

    this.showAttachmentPhotoDialog = false
    this.currentAttachmentIndex = this.currentAttachmentIndex + 1
    this.viewattachment.imageSource = this.attachmentList[this.currentAttachmentIndex].src
    this.checkPhotoPosition()
    this.showAttachmentPhotoDialog = true
  }

  checkPhotoPosition(){

    if(this.currentAttachmentIndex == 0){

      this.isfirstphoto = true;
    }
    else{
      this.isfirstphoto = false;
    }

    if(this.currentAttachmentIndex == (this.attachmentList.length - 1)){

      this.islastphoto = true;
    }
    else{
      this.islastphoto = false;
    }
  }

}
